import './CustomButtons.css'
import { FC } from 'react'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button/button';

export const TransparentButton: FC<ButtonProps> = (props) => {
  return (
    <Button
    {...props}
    className="Transparent-button"
    variant="outlined"
    >
    {props.children}
    </Button>
  )
}

export const MenuButton: FC<ButtonProps> = (props) => {
  return (
    <Button
    {...props}
    className="Menu-button"
    variant="outlined"
    >
    {props.children}
    </Button>
  )
}
